import { Paths } from "@/core/constants/paths";
import { AppLayout } from "@/modules/global/layout";
import { EmbarcacoesPage } from "@/pages/embarcacoes";
import type { ExtendedRouteObject } from "./types";

/**
 * Rotas de campo/obras — adicionar conforme implementação.
 *
 * Embarcações é uma consulta autenticada comum: o recorte por privilégio
 * (`hub.embarcacoes.087`) é aplicado pela API, e a tela apresenta o estado de
 * "sem permissão" a partir do `403` (AC7). O detalhamento da embarcação não
 * tem rota própria: a lupa abre um modal sobre a própria listagem (US-1791).
 */
export const fieldRoutes: ExtendedRouteObject[] = [
  {
    element: <AppLayout />,
    rules: ["user"],
    scope: ["workspace"],
    children: [
      {
        path: Paths.EMBARCACOES,
        element: <EmbarcacoesPage />,
        rules: ["user"],
        scope: ["workspace"],
      },
    ],
  },
];
